var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as Svgs from './jsx';
import * as S from './styles';
export var Icon = forwardRef(function Icon(props, ref) {
    var as = props.as, name = props.name, className = props.className, style = props.style, circled = props.circled, fluid = props.fluid, size = props.size, color = props.color, rest = __rest(props, ["as", "name", "className", "style", "circled", "fluid", "size", "color"]);
    var Svg = Svgs[name];
    var circledClassName = circled ? 'circled' : false;
    var asClassName = as === 'link' ? 'link' : false;
    var fluidClassName = fluid ? 'fluid' : false;
    var sizeClassName = typeof size !== 'number' ? size + "-size" : false;
    var colorClassName = color + "-color";
    var rootClass = cx(circledClassName, asClassName, fluidClassName, sizeClassName, colorClassName, className);
    return (React.createElement(S.Icon, { className: rootClass, style: style },
        React.createElement(Svg, __assign({ name: name, width: typeof size === 'number' ? size : undefined, height: typeof size === 'number' ? size : undefined, ref: ref }, rest))));
});
Icon.defaultProps = {
    as: 'icon',
    color: 'black',
    size: 'medium',
    fluid: false
};
Icon.displayName = 'Icon';
export default Icon;
//# sourceMappingURL=Icon.js.map